// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1lVCT","inner":"Form_inner__1C6se","range":"Form_range__ylRAQ","name":"Form_name__2hyQo","actions":"Form_actions__1vexP"};